// Auth - Cognito import
import {AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool} from 'amazon-cognito-identity-js';
import * as CONST from '../util/app-constants';
import {closenewPasswordModal, opennewPasswordModal} from 'util/util';
import {NotificationManager} from 'react-notifications';

const poolData = {
    UserPoolId: CONST.USER_POOL_ID,
    ClientId: CONST.CLIENT_ID,
};
const userPool = new CognitoUserPool(poolData);

const userData = {
    Username: '',
    Pool: userPool,
};

let cognitoUser;

export function authenticateUser(username, password) {
    const authenticationData = {
        Username: username,
        Password: password,
    };
    const authenticationDetails = new AuthenticationDetails(authenticationData);

    userData.Username = username;
    cognitoUser = new CognitoUser(userData);

    const promiseForAuthentication = new Promise((resolve, reject) => {
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess(result) {
                resolve(result);
            },

            onFailure(err) {
                // console.log("error: ", err);
                // if (err.statusCode == 200) {
                //     // console.log("Success at: ", err.statusCode);
                //     resolve("Authentication Successful");
                // }
                // else {
                //     reject(err);
                // }
                reject(err);
            },
            newPasswordRequired() {
                // User was signed up by an admin and must provide new
                // password and required attributes, if any, to complete
                // authentication.

                // userAttributes: object,
                // which is the user's current profile.
                // It will list all attributes that are associated with the user.
                // Required attributes according to schema,
                // which don’t have any values yet, will have blank values.
                // requiredAttributes: list of attributes that must
                // be set by the user along with new password to complete the sign-in.


                // Get these details and call
                // newPassword: password that user has given
                // attributesData: object with key as attribute name and value that the user has given.
                // cognitoUser.completeNewPasswordChallenge(newPassword, attributesData, this);
                opennewPasswordModal();
                // $('#newPasswordModal').modal('show');
            },
        });
    });

    return promiseForAuthentication;
}

export function setFirstTimePassword(newPassword) {

    const promiseNewPassword = new Promise((resolve, reject) => {

        cognitoUser = userPool.getCurrentUser().getSession((err, session) => {

            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();

            cognitoUser.completeNewPasswordChallenge(newPassword, null, {
                onSuccess(result) {
                    closenewPasswordModal();
                    resolve(result);
                },
                onFailure(error) {
                    NotificationManager.error(error.message);
                    reject(error);
                },
            });
        });
    })

    return promiseNewPassword;
}

export function changePassword(oldPassword, newPassword) {
    cognitoUser = userPool.getCurrentUser();

    const promiseForPasswordChange = new Promise((resolve, reject) => {
        cognitoUser = userPool.getCurrentUser().getSession((err, session) => {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();

            cognitoUser.changePassword(oldPassword, newPassword, (err, result) => {
                if (err) {
                    reject(err);
                }
                resolve(result);
            });
        });
    });

    return promiseForPasswordChange;
}

export function signUp(username, email, password, mobile) {

    let isValidMobileNumber = null;

    const attributeFullName = {
        Name: 'name',
        Value: username,
    };

    // attributePhone;
    const attributePhone = {
        Name: 'phone_number',
        Value: mobile,
    };

    const attributeMail = {
        Name: 'email',
        Value: email,
    };

    const attributePicture = {
        Name: 'picture',
        Value: '',

    };

    // if(mobile !== null){
    //      let phoneExpression = /^\({0,1}((0|\+61)(4)){0,1}\){0,1}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{2}(\ |-){0,1}[0-9]{1}(\ |-){0,1}[0-9]{3}$/;
    //     // let phoneExpression = /^(?:\+?61|0)[2-478](?:[ -]?[0-9]){8}$/;
    //     if((((mobile).match(phoneExpression))&&((mobile.length === 10)||(mobile.length === 12)))){
    //         isValidMobileNumber = true;
    //     }
    //     else {
    //       attributePhone.Value = null;
    //       isValidMobileNumber = false;
    //     }
    // }

    const attributeEmail = new CognitoUserAttribute(attributeMail);
    const attributeName = new CognitoUserAttribute(attributeFullName);
    const attributePhoneNumber = new CognitoUserAttribute(attributePhone);
    const attributeProfileImage = new CognitoUserAttribute(attributePicture);

    const attributeList = [];

    attributeList.push(attributeEmail);
    attributeList.push(attributeName);
    attributeList.push(attributePhoneNumber);
    attributeList.push(attributeProfileImage);


    const promiseForSignUp = new Promise((resolve, reject) => {
        userPool.signUp(username, password, attributeList, null, (err, result) => {
            if (err) {
                reject(err);
                // return;
            }
            else {
                resolve(result);
                cognitoUser = result.user;
            }
        });
    });
    return promiseForSignUp;
}


// Function to get the verification code on Forgot Password
export function sendVerificationCode(username) {
    userData.Username = username;
    cognitoUser = new CognitoUser(userData);
    const promiseForVerificationCode = new Promise((resolve, reject) => {
        cognitoUser.forgotPassword({
            onSuccess(result) {
                resolve(result);
            },
            onFailure(err) {
                reject(err);
            },
            undefined,
        });
    });
    return promiseForVerificationCode;
}

export function confirmResetPassword(verifyCode, newPwd) {
    const promiseForResetToNewPassword = new Promise((resolve, reject) => {
        cognitoUser.confirmPassword(verifyCode, newPwd, {
            onSuccess: () => {
                resolve();
            },
            onFailure: (err) => {
                reject(err);
            },
        });
    });
    return promiseForResetToNewPassword;
}


export function signOut() {
    const promiseForSignOut = new Promise((resolve, reject) => {
        cognitoUser.globalSignOut({
            onSuccess(result) {
                resolve(result);
            },
            onFailure(err) {
                reject(err);
            },
        });
    });

    return promiseForSignOut;
}

export function verifyEmailAddress(verificationCode) {
    cognitoUser = userPool.getCurrentUser();
    const promiseForEmailVerifcation = new Promise((resolve, reject) => {
        cognitoUser = userPool.getCurrentUser().getSession((err, session) => {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();
            cognitoUser.verifyAttribute('email', verificationCode, {
                onSuccess(result) {
                    resolve(result);
                },
                onFailure(err) {
                    reject(err);
                },
            });
        });
    });

    return promiseForEmailVerifcation;
}

export function resendVerificationCode() {
    cognitoUser = userPool.getCurrentUser();
    const promiseForVerificationCode = new Promise((resolve, reject) => {
        cognitoUser = userPool.getCurrentUser().getSession((err, session) => {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();
            cognitoUser.getAttributeVerificationCode('email', {
                onSuccess(result) {
                    resolve(result);
                },
                onFailure(err) {
                    reject(err);
                },
            });
        });
    });

    return promiseForVerificationCode;
}

export function getUserAttributes() {
    cognitoUser = userPool.getCurrentUser();
    const promiseForUserAttributes = new Promise((resolve, reject) => {
        cognitoUser = userPool.getCurrentUser().getSession((err, session) => {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();

            cognitoUser.getUserAttributes((err, result) => {
                if (err) {
                    reject(err);
                }
                else if (result) {
                    resolve(result);
                }
            });
        });
    });

    return promiseForUserAttributes;
}

export function updateUserAttributes(attributeList) {
    cognitoUser = userPool.getCurrentUser();
    const promiseForUpdateUserAttributes = new Promise((resolve, reject) => {
        cognitoUser = userPool.getCurrentUser().getSession((err, session) => {
            cognitoUser.signInUserSession = session;
            cognitoUser.cacheTokens();
            cognitoUser.updateAttributes(attributeList, (err, result) => {
                if (err) {
                    reject(err);
                }
                else if (result) {
                    resolve(result);
                }
            });
        });
    });

    return promiseForUpdateUserAttributes;
}



// WEBPACK FOOTER //
// ./util/user-manager.js